import {
  isParameterizationSystemUserMessage,
  PARAMETERIZATION_SYSTEM_USER_MESSAGE_PREFIXES,
} from './parameterizationMessages';

export const CAMPAIGN_SYSTEM_USER_MESSAGE_PREFIX = 'CAMPANHA_COMPLETA:';

export const AGENT_SYSTEM_USER_MESSAGE_PREFIXES = [
  ...PARAMETERIZATION_SYSTEM_USER_MESSAGE_PREFIXES,
  CAMPAIGN_SYSTEM_USER_MESSAGE_PREFIX,
];

export function isCampaignSystemUserMessage(text) {
  if (!text || typeof text !== 'string') {
    return false;
  }

  return text.trim().startsWith(CAMPAIGN_SYSTEM_USER_MESSAGE_PREFIX);
}

export const TOOL_ERROR_PREFIX = 'TOOL_ERROR:';

export function isToolErrorSystemMessage(text) {
  if (!text || typeof text !== 'string') {
    return false;
  }
  return text.trim().startsWith(TOOL_ERROR_PREFIX);
}

export function isAgentSystemUserMessage(text) {
  return (
    isParameterizationSystemUserMessage(text) ||
    isCampaignSystemUserMessage(text) ||
    isToolErrorSystemMessage(text)
  );
}

export function buildCampaignTypeCompletionMessage(value) {
  return `CAMPANHA_COMPLETA: tipo_campanha ${value}`;
}

export {
  buildPostQuantityCompletionMessage,
  buildImagesCompletionMessage,
  buildStrategyApprovalCompletionMessage,
  buildArtsApprovalCompletionMessage,
  buildCompletionModeMessage,
  buildSocialNetworksCompletionMessage,
  buildScheduleConfigCompletionMessage,
  buildBatchEditConfirmMessage,
  buildFinalActionCompletionMessage,
} from './campaignCompletionMessages';
